import TreatmentPage from "./TreatmentPage";

export default function LaserHairRemoval() {
  return (
    <TreatmentPage
      title="Laser Hair Removal Treatment"
      heroImage="/Treatment/laser_hair_removal_drtruptis-clinic.png"
      intro="LHR- Laser hair removal is non invasive procedure  to  destroy hair follicles ."
      description="Laser Hair Reduction (LHR) is a safe, non-invasive cosmetic procedure that uses concentrated light beams to destroy hair follicles, significantly reducing or stopping future hair growth."
      howItWorks="The concentrated light beams to destroy hair follicles and stop the future hair growth."
      benefits={[
        "Painless",
        "Long lasting effect.",
        "Eliminate ingrows hair",
        "Time and Money saving",
        "Improve skin condition",
        "Safe in all skin type",
      ]}
      beforeAfterImages={[
        "/Treatment/before-laser-hair-removal-truptis-clinic.jpeg",
        "/Treatment/after-laser-hair-removal-truptis-clinic.jpeg",
      ]}
      faqs={[
        { q: "Is it painful?", a: "Mild discomfort only, done under cooling gel." },
        { q: "How many sessions needed?", a: "Usually 4-6 sessions." },
      ]}
    />
  );
}
